// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/images/loading.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/images/prev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/images/next.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/images/close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.lb-disable-scrolling {
    overflow: hidden;
    /* Position fixed required for iOS. Just putting overflow: hidden; on the body is not enough. */
    position: fixed;
    height: 100vh;
    width: 100vw;
  }
  
  .lightboxOverlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: black;
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=95);
    opacity: 0.95;
    display: none;
  }
  
  .lightbox {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 10000;
    text-align: center;
    line-height: 0;
    font-weight: normal;
  }
  
  .lightbox .lb-image {
    display: block;
    height: auto;
    max-width: inherit;
    max-height: none;
    border-radius: 5px;
  }
  
  .lightbox a img {
    border: none;
  }
  
  .lb-outerContainer {
    position: relative;
    *zoom: 1;
    width: 250px;
    height: 250px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: white;
  }
  
  .lb-outerContainer:after {
    content: "";
    display: table;
    clear: both;
  }
  
  .lb-loader {
    position: absolute;
    top: 43%;
    left: 0;
    height: 25%;
    width: 100%;
    text-align: center;
    line-height: 0;
  }
  
  .lb-cancel {
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 auto;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  }
  
  .lb-nav {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
  }
  
  .lb-container > .nav {
    left: 0;
  }
  
  .lb-nav a {
    outline: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  .lb-prev, .lb-next {
    height: 100%;
    cursor: pointer;
    display: block;
  }
  
  .lb-nav a.lb-prev {
    width: 34%;
    left: 0;
    float: left;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) left 48% no-repeat;
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
    transition: opacity 0.6s;
  }
  
  .lb-nav a.lb-prev:hover {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  
  .lb-nav a.lb-next {
    width: 64%;
    right: 0;
    float: right;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) right 48% no-repeat;
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    opacity: 0;
    transition: opacity 0.6s;
  }
  
  .lb-nav a.lb-next:hover {
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  
  .lb-dataContainer {
    margin: 0 auto;
    padding-top: 5px;
    *zoom: 1;
    width: 100%;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  
  .lb-dataContainer:after {
    content: "";
    display: table;
    clear: both;
  }
  
  .lb-data {
    padding: 0 4px;
    color: #ccc;
  }
  
  .lb-data .lb-details {
    margin-top: 10px;
    width: 85%;
    float: left;
    text-align: left;
    line-height: 1.1em;
  }
  
  .lb-data .lb-caption {
    font-size: 13px;
    font-weight: bold;
    line-height: 1em;
  }
  
  .lb-data .lb-caption a {
    color: #4ae;
  }
  
  .lb-data .lb-number {
    display: block;
    clear: left;
    padding-bottom: 1em;
    font-size: 12px;
    color: #999999;
  }
  
  .lb-data .lb-close {
    display: block;
    float: right;
    width: 30px;
    height: 30px;
    margin-top: 15px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) top right no-repeat;
    text-align: right;
    outline: none;
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);
    opacity: 0.7;
    transition: opacity 0.2s;
  }
  
  .lb-data .lb-close:hover {
    cursor: pointer;
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/LightBox.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+FAA+F;IAC/F,eAAe;IACf,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,2DAA2D;IAC3D,aAAa;IACb,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;KAClB,OAAQ;IACR,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6DAA8D;EAChE;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,aAAa;IACb,yDAA2G;EAC7G;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,OAAO;IACP,WAAW;IACX,sEAAoE;IACpE,0DAA0D;IAC1D,UAAU;IAIV,wBAAwB;EAC1B;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,uEAAqE;IACrE,0DAA0D;IAC1D,UAAU;IAIV,wBAAwB;EAC1B;;EAEA;IACE,4DAA4D;IAC5D,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,gBAAgB;KAChB,OAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uEAAsE;IACtE,iBAAiB;IACjB,aAAa;IACb,2DAA2D;IAC3D,YAAY;IAIZ,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,4DAA4D;IAC5D,UAAU;EACZ","sourcesContent":["html.lb-disable-scrolling {\n    overflow: hidden;\n    /* Position fixed required for iOS. Just putting overflow: hidden; on the body is not enough. */\n    position: fixed;\n    height: 100vh;\n    width: 100vw;\n  }\n  \n  .lightboxOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    background-color: black;\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=95);\n    opacity: 0.95;\n    display: none;\n  }\n  \n  .lightbox {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    z-index: 10000;\n    text-align: center;\n    line-height: 0;\n    font-weight: normal;\n  }\n  \n  .lightbox .lb-image {\n    display: block;\n    height: auto;\n    max-width: inherit;\n    max-height: none;\n    border-radius: 5px;\n  }\n  \n  .lightbox a img {\n    border: none;\n  }\n  \n  .lb-outerContainer {\n    position: relative;\n    *zoom: 1;\n    width: 250px;\n    height: 250px;\n    margin: 0 auto;\n    border-radius: 4px;\n    background-color: white;\n  }\n  \n  .lb-outerContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  \n  .lb-loader {\n    position: absolute;\n    top: 43%;\n    left: 0;\n    height: 25%;\n    width: 100%;\n    text-align: center;\n    line-height: 0;\n  }\n  \n  .lb-cancel {\n    display: block;\n    width: 32px;\n    height: 32px;\n    margin: 0 auto;\n    background: url(../public/assets/images/loading.gif) no-repeat;\n  }\n  \n  .lb-nav {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n  }\n  \n  .lb-container > .nav {\n    left: 0;\n  }\n  \n  .lb-nav a {\n    outline: none;\n    background-image: url('data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');\n  }\n  \n  .lb-prev, .lb-next {\n    height: 100%;\n    cursor: pointer;\n    display: block;\n  }\n  \n  .lb-nav a.lb-prev {\n    width: 34%;\n    left: 0;\n    float: left;\n    background: url(../public/assets/images/prev.png) left 48% no-repeat;\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);\n    opacity: 0;\n    -webkit-transition: opacity 0.6s;\n    -moz-transition: opacity 0.6s;\n    -o-transition: opacity 0.6s;\n    transition: opacity 0.6s;\n  }\n  \n  .lb-nav a.lb-prev:hover {\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n    opacity: 1;\n  }\n  \n  .lb-nav a.lb-next {\n    width: 64%;\n    right: 0;\n    float: right;\n    background: url(../public/assets/images/next.png) right 48% no-repeat;\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);\n    opacity: 0;\n    -webkit-transition: opacity 0.6s;\n    -moz-transition: opacity 0.6s;\n    -o-transition: opacity 0.6s;\n    transition: opacity 0.6s;\n  }\n  \n  .lb-nav a.lb-next:hover {\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n    opacity: 1;\n  }\n  \n  .lb-dataContainer {\n    margin: 0 auto;\n    padding-top: 5px;\n    *zoom: 1;\n    width: 100%;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n  \n  .lb-dataContainer:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n  \n  .lb-data {\n    padding: 0 4px;\n    color: #ccc;\n  }\n  \n  .lb-data .lb-details {\n    margin-top: 10px;\n    width: 85%;\n    float: left;\n    text-align: left;\n    line-height: 1.1em;\n  }\n  \n  .lb-data .lb-caption {\n    font-size: 13px;\n    font-weight: bold;\n    line-height: 1em;\n  }\n  \n  .lb-data .lb-caption a {\n    color: #4ae;\n  }\n  \n  .lb-data .lb-number {\n    display: block;\n    clear: left;\n    padding-bottom: 1em;\n    font-size: 12px;\n    color: #999999;\n  }\n  \n  .lb-data .lb-close {\n    display: block;\n    float: right;\n    width: 30px;\n    height: 30px;\n    margin-top: 15px;\n    background: url(../public/assets/images/close.png) top right no-repeat;\n    text-align: right;\n    outline: none;\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);\n    opacity: 0.7;\n    -webkit-transition: opacity 0.2s;\n    -moz-transition: opacity 0.2s;\n    -o-transition: opacity 0.2s;\n    transition: opacity 0.2s;\n  }\n  \n  .lb-data .lb-close:hover {\n    cursor: pointer;\n    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\n    opacity: 1;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
